import api from '@/services/api'

const moduleStops = {
  state: {
    stops: [],
  },
  mutations: {
    STOPS: (state, data) => {
      state.stops = data.map(item => Object.freeze(item))
    },
  },
  actions: {
    STOPS_REQUEST: ({ commit }) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get('stops/')
        .then(response => {
          if (response.data) {
            commit('STOPS', response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
      })
    },
  },
  getters: {
    STOPS: state => state.stops
  }
}
export default moduleStops